function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// ----------------------------------------------------------------------------
// Section: Sticky Add To Cart <sticky-add-to-cart>
// ----------------------------------------------------------------------------
// Persistent product bar that mirrors the main Product section selection and
// submits its form. Visibility is driven by an IntersectionObserver on a
// configurable trigger (default #add-to-cart).
// ----------------------------------------------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import registerCustomElement from 'scripts/helpers/register-custom-element';
import { formatMoneyCents, getOfferCents, offerHasSellingUi, PRICE_TOKEN, waitForOfferPrices } from 'snippets/product-form/ordergroove-offer/ordergroove-offer--per-day';
import './_sticky-add-to-cart.scss';

// -------------------------------------
// Constants
// -------------------------------------

var PRODUCT_FORM_SELECTOR = 'iam-product-form[data-section-type="main-product"]';
var SUBSCRIPTION_BLOCK_SELECTOR = 'subscription-options-block';
var SELECTED_SIZE_SELECTOR = '.subscription-options__size.is-selected, .subscription-options__size[aria-current="page"]';
var OBSERVER_THRESHOLDS = [0, 0.01, 1];
var SOURCE = 'sections/sticky-add-to-cart/sticky-add-to-cart.js';

// -------------------------------------
// Web Component
// -------------------------------------
var _productForm = /*#__PURE__*/new WeakMap();
var _formId = /*#__PURE__*/new WeakMap();
var _triggerSelector = /*#__PURE__*/new WeakMap();
var _perDayTemplate = /*#__PURE__*/new WeakMap();
var _visibilityObserver = /*#__PURE__*/new WeakMap();
var _triggerElement = /*#__PURE__*/new WeakMap();
var _subscriptions = /*#__PURE__*/new WeakMap();
var _isProductFormReady = /*#__PURE__*/new WeakMap();
var _atcMounted = /*#__PURE__*/new WeakMap();
var _atcSubmitAbortController = /*#__PURE__*/new WeakMap();
var _onOfferReceived = /*#__PURE__*/new WeakMap();
var _aside = /*#__PURE__*/new WeakMap();
var _mediaEl = /*#__PURE__*/new WeakMap();
var _compareEls = /*#__PURE__*/new WeakMap();
var _priceEls = /*#__PURE__*/new WeakMap();
var _perDayEl = /*#__PURE__*/new WeakMap();
var _atcHost = /*#__PURE__*/new WeakMap();
var _StickyAddToCart_brand = /*#__PURE__*/new WeakSet();
class StickyAddToCart extends HTMLElement {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _StickyAddToCart_brand);
    _classPrivateFieldInitSpec(this, _productForm, null);
    _classPrivateFieldInitSpec(this, _formId, '');
    _classPrivateFieldInitSpec(this, _triggerSelector, '#add-to-cart');
    _classPrivateFieldInitSpec(this, _perDayTemplate, '');
    _classPrivateFieldInitSpec(this, _visibilityObserver, null);
    _classPrivateFieldInitSpec(this, _triggerElement, null);
    _classPrivateFieldInitSpec(this, _subscriptions, []);
    _classPrivateFieldInitSpec(this, _isProductFormReady, false);
    _classPrivateFieldInitSpec(this, _atcMounted, false);
    _classPrivateFieldInitSpec(this, _atcSubmitAbortController, null);
    _classPrivateFieldInitSpec(this, _onOfferReceived, () => {
      window.requestAnimationFrame(() => _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this));
    });
    _classPrivateFieldInitSpec(this, _aside, null);
    _classPrivateFieldInitSpec(this, _mediaEl, null);
    _classPrivateFieldInitSpec(this, _compareEls, []);
    _classPrivateFieldInitSpec(this, _priceEls, []);
    _classPrivateFieldInitSpec(this, _perDayEl, null);
    _classPrivateFieldInitSpec(this, _atcHost, null);
  }
  connectedCallback() {
    _classPrivateFieldSet(_productForm, this, document.querySelector(PRODUCT_FORM_SELECTOR));
    if (!_classPrivateFieldGet(_productForm, this)) {
      this.remove();
      return;
    }
    _classPrivateFieldSet(_formId, this, _classPrivateFieldGet(_productForm, this).dataset.formId);
    _classPrivateFieldSet(_triggerSelector, this, this.dataset.triggerSelector || '#add-to-cart');
    _classPrivateFieldSet(_perDayTemplate, this, this.dataset.perDayTemplate || "".concat(PRICE_TOKEN, "/day"));
    _classPrivateFieldSet(_aside, this, this.querySelector('.sticky-add-to-cart__aside'));
    _classPrivateFieldSet(_mediaEl, this, this.querySelector('[data-sticky-media]'));
    _classPrivateFieldSet(_compareEls, this, this.querySelectorAll('[data-sticky-compare]'));
    _classPrivateFieldSet(_priceEls, this, this.querySelectorAll('[data-sticky-price]'));
    _classPrivateFieldSet(_perDayEl, this, this.querySelector('[data-sticky-per-day]'));
    _classPrivateFieldSet(_atcHost, this, this.querySelector('[data-sticky-atc-host]'));
    _assertClassBrand(_StickyAddToCart_brand, this, _initVisibilityObserver).call(this);
    if (_classPrivateFieldGet(_productForm, this).ProductForm) {
      _assertClassBrand(_StickyAddToCart_brand, this, _onProductFormReady).call(this);
    } else {
      iamotaEventHandler.subscribe('productForm:init', () => _assertClassBrand(_StickyAddToCart_brand, this, _onProductFormReady).call(this), {
        context: _classPrivateFieldGet(_productForm, this),
        source: SOURCE
      });
    }
    document.addEventListener('og-receive-offer', _classPrivateFieldGet(_onOfferReceived, this));
  }
  disconnectedCallback() {
    var _classPrivateFieldGet2, _classPrivateFieldGet3;
    (_classPrivateFieldGet2 = _classPrivateFieldGet(_visibilityObserver, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.disconnect();
    document.removeEventListener('og-receive-offer', _classPrivateFieldGet(_onOfferReceived, this));
    (_classPrivateFieldGet3 = _classPrivateFieldGet(_atcSubmitAbortController, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.abort();
    for (var {
      event,
      handler
    } of _classPrivateFieldGet(_subscriptions, this)) {
      iamotaEventHandler.unsubscribe(event, handler, {
        context: _classPrivateFieldGet(_productForm, this)
      });
    }
  }
}
function _onProductFormReady() {
  if (_classPrivateFieldGet(_isProductFormReady, this)) return;
  _classPrivateFieldSet(_isProductFormReady, this, true);
  _assertClassBrand(_StickyAddToCart_brand, this, _mountAtcButton).call(this);
  _assertClassBrand(_StickyAddToCart_brand, this, _bindProductFormEvents).call(this);
  _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this);
  waitForOfferPrices(() => _classPrivateGetter(_StickyAddToCart_brand, this, _get_offer), () => _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this));
}
function _mountAtcButton() {
  var _classPrivateFieldGet4;
  if (_classPrivateFieldGet(_atcMounted, this)) return;
  var template = this.querySelector('[data-sticky-atc-template]');
  if (!template || !_classPrivateFieldGet(_atcHost, this) || !_classPrivateFieldGet(_formId, this)) return;
  var fragment = template.content.cloneNode(true);
  var atc = fragment.querySelector('iam-add-to-cart-button');
  if (atc) {
    atc.dataset.formId = _classPrivateFieldGet(_formId, this);
  }
  _classPrivateFieldGet(_atcHost, this).replaceChildren(fragment);
  var mountedAtc = _classPrivateFieldGet(_atcHost, this).querySelector('iam-add-to-cart-button');
  _classPrivateFieldSet(_atcMounted, this, true);
  if (mountedAtc !== null && mountedAtc !== void 0 && mountedAtc.onParentFormInit && (_classPrivateFieldGet4 = _classPrivateFieldGet(_productForm, this)) !== null && _classPrivateFieldGet4 !== void 0 && _classPrivateFieldGet4.ProductForm) {
    mountedAtc.onParentFormInit({
      iamForm: _classPrivateFieldGet(_productForm, this)
    });
  }
  _assertClassBrand(_StickyAddToCart_brand, this, _bindStickyAtcSubmit).call(this, mountedAtc);
  _assertClassBrand(_StickyAddToCart_brand, this, _bindStickyAtcValidation).call(this, mountedAtc);
  if (_classPrivateFieldGet(_productForm, this).validator && mountedAtc !== null && mountedAtc !== void 0 && mountedAtc.refreshState) {
    mountedAtc.refreshState();
  } else if (mountedAtc !== null && mountedAtc !== void 0 && mountedAtc.refreshState) {
    iamotaEventHandler.subscribe('productForm:validation:init', () => {
      mountedAtc.refreshState();
    }, {
      context: _classPrivateFieldGet(_productForm, this),
      source: SOURCE
    });
  }
}
function _bindStickyAtcValidation(atc) {
  if (!(atc !== null && atc !== void 0 && atc.refreshState)) return;
  var handler = () => atc.refreshState();
  iamotaEventHandler.subscribe('productForm:validation:changed', handler, {
    context: _classPrivateFieldGet(_productForm, this),
    source: SOURCE
  });
  _classPrivateFieldGet(_subscriptions, this).push({
    event: 'productForm:validation:changed',
    handler
  });
}
function _getMainSubmitButton() {
  var _classPrivateFieldGet5, _classPrivateFieldGet6;
  return ((_classPrivateFieldGet5 = _classPrivateFieldGet(_productForm, this)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.querySelector('#add-to-cart')) || ((_classPrivateFieldGet6 = _classPrivateFieldGet(_productForm, this)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.querySelector('iam-add-to-cart-button button[type="submit"]'));
}
function _submitProductForm(fallbackSubmitter) {
  var _classPrivateFieldGet7;
  var form = (_classPrivateFieldGet7 = _classPrivateFieldGet(_productForm, this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.form;
  if (!form) return;
  var submitter = _assertClassBrand(_StickyAddToCart_brand, this, _getMainSubmitButton).call(this) || fallbackSubmitter;
  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit(submitter || undefined);
    return;
  }
  submitter === null || submitter === void 0 || submitter.click();
}
function _bindStickyAtcSubmit(atc) {
  var _classPrivateFieldGet8, _classPrivateFieldGet0;
  var form = (_classPrivateFieldGet8 = _classPrivateFieldGet(_productForm, this)) === null || _classPrivateFieldGet8 === void 0 ? void 0 : _classPrivateFieldGet8.form;
  var button = atc === null || atc === void 0 ? void 0 : atc.control;
  if (!form || !button) {
    window.requestAnimationFrame(() => {
      var _classPrivateFieldGet9;
      var retryAtc = (_classPrivateFieldGet9 = _classPrivateFieldGet(_atcHost, this)) === null || _classPrivateFieldGet9 === void 0 ? void 0 : _classPrivateFieldGet9.querySelector('iam-add-to-cart-button');
      if (retryAtc) _assertClassBrand(_StickyAddToCart_brand, this, _bindStickyAtcSubmit).call(this, retryAtc);
    });
    return;
  }
  var formId = form.getAttribute('id');
  if (formId) {
    button.setAttribute('form', formId);
  }
  (_classPrivateFieldGet0 = _classPrivateFieldGet(_atcSubmitAbortController, this)) === null || _classPrivateFieldGet0 === void 0 || _classPrivateFieldGet0.abort();
  _classPrivateFieldSet(_atcSubmitAbortController, this, new AbortController());
  button.addEventListener('click', event => {
    if (button.disabled) return;

    // External submit must dispatch the Product form submit event so
    // ProductForm + just-validate run the same AJAX path as in-form ATC.
    event.preventDefault();
    _assertClassBrand(_StickyAddToCart_brand, this, _submitProductForm).call(this, button);
  }, {
    signal: _classPrivateFieldGet(_atcSubmitAbortController, this).signal
  });
}
function _bindProductFormEvents() {
  var subscribe = (event, handler) => {
    iamotaEventHandler.subscribe(event, handler, {
      context: _classPrivateFieldGet(_productForm, this),
      source: SOURCE
    });
    _classPrivateFieldGet(_subscriptions, this).push({
      event,
      handler
    });
  };
  subscribe('productForm:variant:changed', _ref => {
    var {
      variant
    } = _ref;
    return _assertClassBrand(_StickyAddToCart_brand, this, _onVariantChange).call(this, variant);
  });
  subscribe('productForm:quantity:changed', () => _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this));
  subscribe('productForm:sellingPlan:changed', () => _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this));
  subscribe('productForm:sellingPlanInput:changed', () => _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this));
  subscribe('productForm:purchaseMode:changed', () => _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this));
}
function _initVisibilityObserver() {
  _classPrivateFieldSet(_triggerElement, this, _assertClassBrand(_StickyAddToCart_brand, this, _resolveTrigger).call(this));
  if (!_classPrivateFieldGet(_triggerElement, this)) {
    _assertClassBrand(_StickyAddToCart_brand, this, _setHidden).call(this, true);
    return;
  }
  _classPrivateFieldSet(_visibilityObserver, this, new IntersectionObserver(entries => _assertClassBrand(_StickyAddToCart_brand, this, _onTriggerIntersection).call(this, entries[0]), {
    threshold: OBSERVER_THRESHOLDS
  }));
  _classPrivateFieldGet(_visibilityObserver, this).observe(_classPrivateFieldGet(_triggerElement, this));
  _assertClassBrand(_StickyAddToCart_brand, this, _setHidden).call(this, true);
}
function _resolveTrigger() {
  var selector = _classPrivateFieldGet(_triggerSelector, this).trim();
  if (!selector) return null;
  try {
    return document.querySelector(selector);
  } catch (_unused) {
    return null;
  }
}
function _onTriggerIntersection(entry) {
  if (!entry) return;
  var isFullyVisible = entry.intersectionRatio >= 1;
  var isScrolledPast = entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0;
  _assertClassBrand(_StickyAddToCart_brand, this, _setHidden).call(this, isFullyVisible || !isScrolledPast);
}
function _setHidden(isHidden) {
  this.classList.toggle('sticky-add-to-cart--hidden', isHidden);
  this.classList.toggle('sticky-add-to-cart--showing', !isHidden);
  this.toggleAttribute('hidden', isHidden);
  this.toggleAttribute('inert', isHidden);
  if (_classPrivateFieldGet(_aside, this)) {
    _classPrivateFieldGet(_aside, this).setAttribute('aria-hidden', String(isHidden));
  }
}
function _onVariantChange(variant) {
  if (!variant) return;
  _assertClassBrand(_StickyAddToCart_brand, this, _updateMedia).call(this, variant);
  _assertClassBrand(_StickyAddToCart_brand, this, _refreshPricing).call(this, variant);
}
function _updateMedia(variant) {
  if (!_classPrivateFieldGet(_mediaEl, this) || _classPrivateFieldGet(_mediaEl, this).tagName !== 'IMG') return;
  var featured = variant.featured_media || variant.featured_image;
  var preview = (featured === null || featured === void 0 ? void 0 : featured.preview_image) || featured;
  if (preview !== null && preview !== void 0 && preview.src) {
    var separator = preview.src.includes('?') ? '&' : '?';
    _classPrivateFieldGet(_mediaEl, this).src = "".concat(preview.src).concat(separator, "width=120");
    _classPrivateFieldGet(_mediaEl, this).hidden = false;
  }
}
function _getPurchaseMode() {
  var _classPrivateFieldGet1;
  return ((_classPrivateFieldGet1 = _classPrivateFieldGet(_productForm, this)) === null || _classPrivateFieldGet1 === void 0 ? void 0 : _classPrivateFieldGet1.dataset.purchaseMode) === 'one_time' ? 'one_time' : 'subscription';
}
function _refreshPricing() {
  var _classPrivateFieldGet10, _classPrivateFieldGet11;
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_classPrivateFieldGet10 = _classPrivateFieldGet(_productForm, this)) === null || _classPrivateFieldGet10 === void 0 || (_classPrivateFieldGet11 = _classPrivateFieldGet10.getCurrentVariant) === null || _classPrivateFieldGet11 === void 0 ? void 0 : _classPrivateFieldGet11.call(_classPrivateFieldGet10);
  _assertClassBrand(_StickyAddToCart_brand, this, _refreshMainPrice).call(this, variant);
  _assertClassBrand(_StickyAddToCart_brand, this, _refreshPerDay).call(this);
}
function _refreshMainPrice(variant) {
  if (!_classPrivateFieldGet(_priceEls, this).length) return;
  var offer = _classPrivateGetter(_StickyAddToCart_brand, this, _get_offer);
  var purchaseMode = _assertClassBrand(_StickyAddToCart_brand, this, _getPurchaseMode).call(this);
  if (offer && offerHasSellingUi(offer)) {
    var activeCents = getOfferCents(offer, purchaseMode);
    if (activeCents != null) {
      _assertClassBrand(_StickyAddToCart_brand, this, _setPriceText).call(this, formatMoneyCents(activeCents));
      _assertClassBrand(_StickyAddToCart_brand, this, _setComparePrice).call(this, variant, offer, purchaseMode, activeCents);
      return;
    }
  }
  _assertClassBrand(_StickyAddToCart_brand, this, _setVariantPrice).call(this, variant);
}
function _setPriceText(text) {
  for (var priceEl of _classPrivateFieldGet(_priceEls, this)) {
    priceEl.textContent = text;
  }
}
function _setComparePrice(variant, offer, purchaseMode, activeCents) {
  if (!_classPrivateFieldGet(_compareEls, this).length) return;
  if (purchaseMode === 'subscription') {
    var oneTimeCents = getOfferCents(offer, 'one_time');
    if (oneTimeCents != null && oneTimeCents > activeCents) {
      _assertClassBrand(_StickyAddToCart_brand, this, _setCompareText).call(this, formatMoneyCents(oneTimeCents), false);
      return;
    }
  } else if ((variant === null || variant === void 0 ? void 0 : variant.compare_at_price) > (variant === null || variant === void 0 ? void 0 : variant.price)) {
    _assertClassBrand(_StickyAddToCart_brand, this, _setCompareText).call(this, formatMoneyCents(variant.compare_at_price), false);
    return;
  }
  _assertClassBrand(_StickyAddToCart_brand, this, _setCompareText).call(this, '', true);
}
function _setCompareText(text, isHidden) {
  for (var compareEl of _classPrivateFieldGet(_compareEls, this)) {
    compareEl.textContent = text;
    compareEl.hidden = isHidden;
  }
}
function _setVariantPrice(variant) {
  if (!variant || !_classPrivateFieldGet(_priceEls, this).length) return;
  _assertClassBrand(_StickyAddToCart_brand, this, _setPriceText).call(this, formatMoneyCents(variant.price));
  if (!_classPrivateFieldGet(_compareEls, this).length) return;
  if (variant.compare_at_price > variant.price) {
    _assertClassBrand(_StickyAddToCart_brand, this, _setCompareText).call(this, formatMoneyCents(variant.compare_at_price), false);
  } else {
    _assertClassBrand(_StickyAddToCart_brand, this, _setCompareText).call(this, '', true);
  }
}
function _get_subscriptionBlock(_this) {
  var _classPrivateFieldGet12;
  return (_classPrivateFieldGet12 = _classPrivateFieldGet(_productForm, _this)) === null || _classPrivateFieldGet12 === void 0 ? void 0 : _classPrivateFieldGet12.querySelector(SUBSCRIPTION_BLOCK_SELECTOR);
}
function _get_offer(_this2) {
  var _classPrivateGetter2;
  return ((_classPrivateGetter2 = _classPrivateGetter(_StickyAddToCart_brand, _this2, _get_subscriptionBlock)) === null || _classPrivateGetter2 === void 0 ? void 0 : _classPrivateGetter2.querySelector('iam-ordergroove-offer')) || null;
}
function _get_supplyDays(_this3) {
  var _block$querySelector;
  var block = _classPrivateGetter(_StickyAddToCart_brand, _this3, _get_subscriptionBlock);
  if (!block) return null;
  var selected = (_block$querySelector = block.querySelector(SELECTED_SIZE_SELECTOR)) === null || _block$querySelector === void 0 ? void 0 : _block$querySelector.querySelector('[data-supply-days]');
  var days = Number(selected === null || selected === void 0 ? void 0 : selected.dataset.supplyDays) || Number(block.dataset.supplyDays);
  return days > 0 ? days : null;
}
function _refreshPerDay() {
  if (!_classPrivateFieldGet(_perDayEl, this)) return;
  var offer = _classPrivateGetter(_StickyAddToCart_brand, this, _get_offer);
  var supplyDays = _classPrivateGetter(_StickyAddToCart_brand, this, _get_supplyDays);
  var purchaseMode = _assertClassBrand(_StickyAddToCart_brand, this, _getPurchaseMode).call(this);
  if (!offer || !supplyDays) {
    _classPrivateFieldGet(_perDayEl, this).textContent = '';
    _classPrivateFieldGet(_perDayEl, this).hidden = true;
    return;
  }
  var cents = getOfferCents(offer, purchaseMode);
  if (cents == null) {
    _classPrivateFieldGet(_perDayEl, this).textContent = '';
    _classPrivateFieldGet(_perDayEl, this).hidden = true;
    return;
  }
  var perDayText = _classPrivateFieldGet(_perDayTemplate, this).replace(PRICE_TOKEN, formatMoneyCents(Math.round(cents / supplyDays)));
  _classPrivateFieldGet(_perDayEl, this).textContent = perDayText;
  _classPrivateFieldGet(_perDayEl, this).hidden = false;
}
registerCustomElement('sticky-add-to-cart', StickyAddToCart);